import { capitalizeString } from '@strata/helper-functions';
import { WarningToast } from '@strata/react-toast-message';

const filterRoles = (roles, roleType) =>
    roles
        ?.filter((role) => role.role_name.startsWith(roleType))
        .map((role) => ({
            name: role.display_name,
            role_name: role.role_name,
            description: role.description,
        })) ?? [];

export const filterSupplierRoles = (roles) => filterRoles(roles, 'marketplace');
export const filterPrescriberRoles = (roles) => filterRoles(roles, 'rta');
export const filterPayerRoles = (roles) => filterRoles(roles, 'aperture');
export const filterCompassRoles = (roles) => filterRoles(roles, 'compass');
export const filterLighthouseRoles = (roles) => filterRoles(roles, 'lighthouse');

export const handleDuplicateUserToast = (upn, userType) => {
    WarningToast({
        message: `${capitalizeString(userType)} User: ${upn} created successfully, but user already exists in Auth0.`,
        timeout: 5000,
    });
};
